import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";
import cellEditFactory from "react-bootstrap-table2-editor";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Spinner,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import { postSubmitForm } from "../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../helpers/show_notification";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../helpers/units";
import preloader from "../../helpers/preloader";
import UpdateQuantityModal from "../../components/UpdateQuantityModal";

const ItemOrderCorrection = (props) => {
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    loadAllStores();
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setAllOrders([]);
    }
  }, [dateFrom, dateTo]);

  const [selectedStore, setSelectedStore] = useState("");
  const [allstores, setAllStore] = useState([]);
  const loadAllStores = async () => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "stores/getall";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        const stores =
          response.data?.filter(
            (d) => d.type === "Branch" || d.type === "CENTRAL KITCHEN STORE",
          ) || [];
        setAllStore(stores);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [allOrders, setAllOrders] = useState([]);
  const loadOrders = async () => {
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setAllOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setAllOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      preloader(true);
      setAllOrders([]);
      let allData = [];
      const url = process.env.REACT_APP_BASEURL + "corrections/get_itemorder";

      if (daysDiff > 5) {
        // Split into 4 parts
        // console.log("multi");
        const daysPerPart = Math.ceil(daysDiff / 4);
        let startDate = moment(dateFrom);
        let endDate = moment(dateTo);

        for (let i = 0; i < 4; i++) {
          const currentEndDate = moment.min(
            startDate.clone().add(daysPerPart, "days"),
            endDate,
          );

          const response = await postSubmitForm(url, {
            date_from: startDate.format("YYYY-MM-DD"),
            date_to: currentEndDate.format("YYYY-MM-DD"),
            store_id: selectedStore,
          });

          if (response && response.status === 1) {
            let result = response.data || [];
            allData = [...allData, ...result];
          } else {
            // showNotification(response.message || "Error", "Error");
          }

          startDate = currentEndDate.clone().add(1, "day");
          if (startDate.isAfter(endDate)) break;
        }
      } else {
        // Single API call
        // console.log("single");

        const response = await postSubmitForm(url, {
          date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
          date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
          store_id: selectedStore,
        });

        if (response && response.status === 1) {
          let result = response.data || [];
          allData = [...allData, ...result];
        } else {
          showNotification(response.message || "Error", "Error");
        }
      }
      if (allData.length <= 0) {
        showNotification("No Orders data found", "error");
      }
      preloader(false);
      const sortedData = allData?.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      );
      setAllOrders(sortedData);
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [received, setRecieved] = useState([]);
  const [yetToReceive, setYetToReceive] = useState([]);

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "order_to",
      text: props.t("Order To"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      text: props.t("From Supplier"),
      dataField: "direct_po",
      formatter: (cell, row) => {
        return row.direct_po ? "Yes" : "No";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Branch Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unit_levels);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const [selectedOrder, setSelectedOrder] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      dataField: "createdAt",
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD-MM-YYYY HH:mm");
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "status",
      sort: true,
      text: props.t("Central Store Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "substore_status",
      sort: true,
      text: props.t("Sub Store Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Is Urgent?"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row) => {
        if (row.is_urgent) {
          return props.t("Yes");
        } else {
          return props.t("No");
        }
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "admin_remarks",
      text: props.t("Centre Remarks"),
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      text: props.t("Action"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      csvExport: false,
      formatter: (cell, row) => {
        return (
          <span className="text-primary">
            <i
              className="mdi mdi-text-box-search font-size-15"
              title="Click to View Details"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setDetailsModal(!detailsModal);
                setSelectedOrder(row);
                setReceiveBtnDisabled(false);
                let received_items = [];
                let to_receive_items = [];
                // console.log();
                row.delivery_details.map((item) => {
                  // console.log(row,"row");
                  if (item.is_received) {
                    item.received_quantity = item.received_quantity;
                    item.new_batch = item.batch_inventory;
                    item.updated_receive = item.received_quantity;
                    item.delivered_quantity = item.delivered_quantity;
                    received_items.push(item);
                  }
                });
                // console.log(received_items,"RECITEMS");

                setRecieved(received_items);
                setYetToReceive(to_receive_items);
              }}
            ></i>
          </span>
        );
      },
    },
  ];

  const handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      setExpanded([...expanded, row._id]);
    } else {
      setExpanded(expanded.filter((x) => x !== row._id));
    }
  };

  const [expanded, setExpanded] = useState([]);
  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.item_details}
          columns={columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
    expanded: expanded,
    onExpand: handleOnExpand,
  };

  const rowStyle = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    const cs = row.status;
    const ss = row.substore_status;
    if (cs === "Closed" || ss === "Closed") {
      style.backgroundColor = "#b8ffb9";
    } else if (cs === "Placed" || ss === "Placed") {
      style.backgroundColor = "#ffb8b8";
    } else if (cs === "Rejected" || cs === "Rejected") {
      style.backgroundColor = "#f1b8ff";
    } else {
      style.backgroundColor = "#b8cdff";
    }
    return style;
  };

  function compareQuantities(item) {
    const quantities = item.updated_receive;
    const quantitiesToCompare = item.delivered_quantity;
    const unitLevels = item.unit_levels;
    const convertedQuantities = convertToLowestUnit(unitLevels, quantities);
    const convertedQuantitiesToCompare = convertToLowestUnit(
      unitLevels,
      quantitiesToCompare,
    );
    let isPartial = false;
    if (convertedQuantities < convertedQuantitiesToCompare) {
      isPartial = true;
    }
    return isPartial;
  }

  const [detailsModal, setDetailsModal] = useState(false);
  const handleOrderCorrection = async (e, v) => {
    try {
      setReceiveBtnDisabled(true);
      let order_id = selectedOrder.order_id;
      let delivery_details = received.map((item) => {
        let mappedItem = { ...item };
        if (item.type) {
          mappedItem.type = item.type;
          mappedItem.order_quantity = item.quantity;
          mappedItem.batch_inventory = item.new_batch;
          mappedItem.before_correction_quantity = item.received_quantity;
          mappedItem.received_quantity = item.updated_receive.map(
            ({ unit, value }) => ({ unit, value: Number(value) }),
          );
          mappedItem.correction_quantity = item.correction_quantity.map(
            ({ unit, value }) => ({ unit, value: Number(value) }),
          );
        }
        delete mappedItem.updated_receive;
        delete mappedItem.initial_order_quantity;
        return mappedItem;
      });
      const data_to_send = {
        order_id,
        delivery_details,
        store_id: selectedStore,
      };
      let isNoRemarkUpdated = false;
      // for (let item of received) {
      //   isNoRemarkUpdated = compareQuantities(item);
      //   if (isNoRemarkUpdated && item.remarks==="") {
      //     showNotification("Enter remarks for all variances in received items.",
      //       "Warning"
      //     );
      //     setReceiveBtnDisabled(false)
      //     return;
      //   }
      // }
      // console.log(data_to_send,"pay");
      // return
      let url =
        process.env.REACT_APP_BASEURL + "corrections/itemorder_receiving";
      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        setDetailsModal(false);
        loadOrders();
        showNotification(response.message, "Success");
      } else {
        setReceiveBtnDisabled(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setReceiveBtnDisabled(false);
    }
  };
  const columns_received = [
    // {
    //   dataField: "category",
    //   text: props.t("Category"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },
    // {
    //   dataField: "sub_category",
    //   text: props.t("Sub-Category"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
      sort: true,
    },
    {
      text: props.t("From Supplier"),
      dataField: "direct_po",
      formatter: (cell, row) => {
        return row.direct_po ? "Yes" : "No";
      },
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "delivered_from",
      text: props.t("Dispatched From"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Del. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity);
      },
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "batch_inventory",
      text: props.t("Batch Avl."),
      formatter: (cell, row) => {
        const formattedInventory = formatUnitsForReport(row.batch_inventory);
        return (
          <>
            {formattedInventory}
            <br />
            {row.batch ? `( ${row.batch} )` : ""}
          </>
        );
      },
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "new_batch",
      text: props.t("New Batch"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.new_batch);
      },
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: ReceiveFormatter,
      editable: false,
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Remarks"),
      dataField: "remarks",
      editable: true,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const [receiveModal, setReceiveModal] = useState(false);
  function ReceiveFormatter(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.updated_receive && row.updated_receive)}
          </span>
          <Button
            className="btn btn-success btn-sm"
            onClick={() => {
              let updatedItem = {
                ...row,

                quantity: row.updated_receive?.map((item, idx) => ({
                  ...item,
                  index: idx,
                  isChecked: true,
                })),
              };
              setSelectedItem(updatedItem);
              setReceiveModal(true);
            }}
          >
            <i class="mdi mdi-edit"></i>
            {props.t("Edit")}
          </Button>
        </div>
      </>
    );
  }

  const [selectedItem, setSelectedItem] = useState();
  const [receiveBtnDisabled, setReceiveBtnDisabled] = useState(false);

  const handleSubmit = (quantity) => {
    // Validate input
    if (!received || !selectedItem) {
      showNotification("No item selected", "error");
      return;
    }

    // Find the specific item in delivery_details
    const deliveryItem = received.find((item) => item._id === selectedItem._id);

    if (!deliveryItem) {
      showNotification("Item not found", "error");
      return;
    }

    // Convert quantities to the lowest unit for consistent comparison
    const batch_Inv = convertToLowestUnit(
      deliveryItem.unit_levels,
      deliveryItem?.batch_inventory,
    );

    const Received_Qty = convertToLowestUnit(
      deliveryItem.unit_levels,
      deliveryItem?.received_quantity,
    );
    const delivered_Qty = convertToLowestUnit(
      deliveryItem.unit_levels,
      deliveryItem?.delivered_quantity,
    );

    const UpdatedReceived_Qty = convertToLowestUnit(
      deliveryItem.unit_levels,
      deliveryItem?.updated_receive,
    );
    const updated_Qty = convertToLowestUnit(deliveryItem.unit_levels, quantity);
    const lastUnitObj = deliveryItem.unit_levels.at(-1).unit;

    // Early return if no change in quantity
    if (updated_Qty === Received_Qty && UpdatedReceived_Qty === updated_Qty) {
      showNotification("Quantity unchanged", "info");
      return;
    }

    //If entered quantity is greater than dispatched then return
    if (updated_Qty > delivered_Qty) {
      showNotification("cann not update more than dispacthed", "Warning");
      return;
    }

    try {
      let updatedDeliveryDetails;
      let newBatchQuantity;
      let remainingQuantity;
      let correctionQuantityToBeAdded;

      // CASE 1: Exact match with batch inventory
      if (batch_Inv === Received_Qty) {
        // console.log("Exact match with batch inventory", 1);
        const convertedQuantity = GetUpdatedDelivered(
          quantity,
          deliveryItem?.unit_levels,
        );
        const correctionQuantity = [
          {
            unit: lastUnitObj,
            value:
              Received_Qty > updated_Qty
                ? +Received_Qty - +updated_Qty
                : +updated_Qty - +Received_Qty,
          },
        ];
        correctionQuantityToBeAdded = GetUpdatedDelivered(
          correctionQuantity,
          deliveryItem?.unit_levels,
        );
        updatedDeliveryDetails = received.map((item) =>
          item._id === selectedItem._id
            ? {
                ...item,
                type: updated_Qty > Received_Qty ? "Credit" : "Debit",
                correction_quantity: correctionQuantityToBeAdded,
                new_batch: convertedQuantity,
                updated_receive: convertedQuantity,
              }
            : item,
        );
      }
      // CASE 2: Updated quantity is greater than received quantity
      else if (updated_Qty > Received_Qty) {
        // console.log("Updated quantity is greater than received quantity", 2);

        remainingQuantity = Number(updated_Qty) - Number(Received_Qty);

        // Create new batch inventory
        const newInventoryQuantity = [
          { unit: lastUnitObj, value: remainingQuantity + batch_Inv },
        ];
        newBatchQuantity = GetUpdatedDelivered(
          newInventoryQuantity,
          deliveryItem?.unit_levels,
        );

        const correctionQuantity = [
          { unit: lastUnitObj, value: remainingQuantity },
        ];
        correctionQuantityToBeAdded = GetUpdatedDelivered(
          correctionQuantity,
          deliveryItem?.unit_levels,
        );

        updatedDeliveryDetails = received.map((item) =>
          item._id === selectedItem._id
            ? {
                ...item,
                type: updated_Qty > Received_Qty ? "Credit" : "Debit",
                correction_quantity: correctionQuantityToBeAdded,
                new_batch: newBatchQuantity,
                updated_receive: GetUpdatedDelivered(
                  [{ unit: lastUnitObj, value: updated_Qty }],
                  deliveryItem?.unit_levels,
                ),
              }
            : item,
        );
      }
      // CASE 3: Updated quantity is less than received quantity
      else if (updated_Qty < Received_Qty) {
        // console.log("Updated quantity is less than received quantity", 3);

        // Calculate quantity to be returned to batch inventory
        remainingQuantity = Number(Received_Qty) - Number(updated_Qty);
        if (remainingQuantity > batch_Inv) {
          showNotification("Insufficient batch inventory", "Warning");
          return;
        }
        // Create new batch inventory by adding returned quantity
        const newInventoryQuantity = [
          { unit: lastUnitObj, value: batch_Inv - remainingQuantity },
        ];
        newBatchQuantity = GetUpdatedDelivered(
          newInventoryQuantity,
          deliveryItem?.unit_levels,
        );

        const correctionQuantity = [
          { unit: lastUnitObj, value: remainingQuantity },
        ];
        correctionQuantityToBeAdded = GetUpdatedDelivered(
          correctionQuantity,
          deliveryItem?.unit_levels,
        );

        updatedDeliveryDetails = received.map((item) =>
          item._id === selectedItem._id
            ? {
                ...item,
                type: updated_Qty > Received_Qty ? "Credit" : "Debit",
                correction_quantity: correctionQuantityToBeAdded,
                new_batch: newBatchQuantity,
                updated_receive: GetUpdatedDelivered(
                  [{ unit: lastUnitObj, value: updated_Qty }],
                  deliveryItem?.unit_levels,
                ),
              }
            : item,
        );
      }

      // Update states
      setReceiveModal(false);
      setSelectedItem(null);
      setRecieved(updatedDeliveryDetails);

      // showNotification("Inventory updated successfully", "Success");
    } catch (error) {
      console.error("Error updating inventory:", error);
      showNotification("Error updating inventory", "Error");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Order Correction")}
            title={props.t("Corrections")}
            breadcrumbItem={props.t("Items Order Correction")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={() => loadOrders()}>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="store"
                          label={props.t("Store/Branch")}
                          type="select"
                          value={selectedStore}
                          onChange={(e) => {
                            setSelectedStore(e.target.value);
                          }}
                          errorMessage={props.t("Store/Branch is required.")}
                          validate={{
                            required: { value: true },
                          }}
                        >
                          <option value="">
                            {props.t("---Select Store/Branch---")}
                          </option>
                          {allstores &&
                            allstores.map((store) => {
                              return (
                                <option value={store._id}>{store.name}</option>
                              );
                            })}
                        </AvField>
                      </Col>
                      <Col lg={3}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("All Orders")}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns_external}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            expandRow={expandRow}
                            rowStyle={rowStyle}
                            filter={filterFactory()}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  {/* Details Modal starts */}
                  <Modal
                    // size="xl"
                    isOpen={detailsModal}
                    toggle={() => setDetailsModal(!detailsModal)}
                    style={{ width: "1300px", minWidth: "1300px" }}
                  >
                    <ModalHeader toggle={() => setDetailsModal(!detailsModal)}>
                      {props.t("Order Details")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12} md={12}>
                                    <Label>Ordered Items</Label>
                                  </Col>

                                  <Col lg={12}>
                                    <BootstrapTable
                                      bootstrap4
                                      keyField="_id"
                                      data={
                                        selectedOrder &&
                                        selectedOrder.item_details
                                      }
                                      columns={columns}
                                      noDataIndication="No data to display."
                                      striped
                                      hover
                                      condensed
                                    />
                                    <hr />
                                  </Col>

                                  {selectedOrder &&
                                  received &&
                                  received.length > 0 ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>{props.t("Received Items")} </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12} className="mb-4">
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="_id"
                                          key="_id"
                                          data={received}
                                          cellEdit={cellEditFactory({
                                            mode: "click",
                                            blurToSave: true,
                                          })}
                                          columns={columns_received}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                        <hr />
                                      </Col>
                                      <Col lg={12} className="text-center">
                                        <Label>&nbsp;</Label>
                                        <br />
                                        <Button
                                          type="submit"
                                          color="primary"
                                          style={{ width: "100px" }}
                                          disabled={receiveBtnDisabled}
                                          onClick={handleOrderCorrection}
                                          className="btn btn-default waves-effect waves-light"
                                        >
                                          {receiveBtnDisabled ? (
                                            <Spinner size="sm" />
                                          ) : (
                                            props.t("Submit")
                                          )}
                                        </Button>
                                        <hr />
                                      </Col>
                                    </>
                                  ) : null}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                  {/* Details Modal ends */}

                  {/* ---Edit Receive Quantity Modal start--- */}
                  <UpdateQuantityModal
                    isOpen={receiveModal}
                    toggle={() => setReceiveModal(false)}
                    onSubmit={handleSubmit}
                    item={selectedItem}
                  />
                  {/* ---Edit Receive Quantity Modal end--- */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemOrderCorrection)),
);
